import { Paper, Title, Text, Stack, Group, Loader, Center, Badge, Divider } from '@mantine/core';
import { useBackups } from './useBackups';
import dayjs from 'dayjs';

function formatSize(bytes: number) {
  if (bytes >= 1e9) return `${(bytes / 1e9).toFixed(1)} GB`;
  if (bytes >= 1e6) return `${(bytes / 1e6).toFixed(1)} MB`;
  return `${(bytes / 1e3).toFixed(0)} KB`;
}

export function BackupsPanel() {
  const { data: backupsByDb, isLoading, error } = useBackups();

  if (error) {
    return (
      <Paper shadow="xs" p="md" withBorder>
        <Title order={4} mb="md">Letzte Backups</Title>
        <Text c="red">Fehler beim Laden</Text>
      </Paper>
    );
  }

  if (isLoading || !backupsByDb) {
    return (
      <Paper shadow="xs" p="md" withBorder>
        <Title order={4} mb="md">Letzte Backups</Title>
        <Center><Loader size="sm" /></Center>
      </Paper>
    );
  }

  const databases = Object.keys(backupsByDb);

  return (
    <Paper shadow="xs" p="md" withBorder>
      <Title order={4} mb="md">Letzte Backups</Title>
      <Stack gap="sm">
        {databases.map((db, idx) => (
          <Stack key={db} gap="xs">
            {idx > 0 && <Divider />}
            <Group gap="xs">
              <Badge color="blue" variant="light" size="sm">{db}</Badge>
              <Text size="xs" c="dimmed">{backupsByDb[db]?.length ?? 0} Einträge</Text>
            </Group>
            {(backupsByDb[db] ?? []).map((backup, i) => (
              <Group key={i} justify="space-between" px="xs">
                <Text size="xs">{dayjs(backup.lastModified).format('DD.MM.YYYY HH:mm')}</Text>
                <Text size="xs" c="dimmed">{formatSize(backup.size)}</Text>
              </Group>
            ))}
          </Stack>
        ))}
      </Stack>
    </Paper>
  );
}
